import React from 'react';
import Styled from 'styled';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import Image from 'lib/images/image-view';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import TextShortener from 'four-nets/ui-v2/text-shortener/text-shortener';
import IconUser from 'four-nets/icons/svg/icon_user.svg';
import { displayedName } from 'four-nets/user/utils';

import { PanelPostEdgesFragment } from './panel-post-edges.graphql';
import _ from './panel-post.graphql';
import { PostType } from './panel-post.graphql';
import defaultStyles from './panel-posts.scss';

export interface Props extends PanelPostEdgesFragment {
    styles: typeof defaultStyles;
}

class PanelPosts extends React.PureComponent<Props> {
    render() {
        const { styles, edges } = this.props;

        return (
            <div className={styles.panel}>
                {edges.map((edge, index) => {
                    if (!edge || !edge.node) {
                        return null;
                    }
                    const { id, title, slug, images, user, postType, titleImage } = edge.node;

                    const hasImage = titleImage || (images && images.edges && images.edges.length > 0);
                    let photoFile = null;
                    if (hasImage) {
                        photoFile = titleImage || images!.edges[0]!.node!.photoFile;
                    }

                    const type = PostType && 'POST_ARTICLE' === postType ? 'article' : 'album';

                    return (
                        <div className={styles.row} key={id}>
                            <div
                                className={classnames(styles.innerWrapper, {
                                    [styles.noBorder]: edges.length - 1 === index,
                                })}
                            >
                                <div className={styles.image}>
                                    {hasImage ? (
                                        <Link
                                            to={`/blog/${user && user.username}/${type}/${slug}/`}
                                            className={styles.link}
                                        >
                                            <Image
                                                sizes={{ xs: 150 }}
                                                aspectFill={true}
                                                srcSet={photoFile!.srcset!}
                                                src={photoFile!.src}
                                                alt={title}
                                                linkify={false}
                                            />
                                        </Link>
                                    ) : null}
                                </div>
                                <div className={styles.column}>
                                    <Link
                                        to={`/blog/${user && user.username}/${type}/${slug}/`}
                                        className={styles.link}
                                    >
                                        <p className={styles.title}>
                                            <TextShortener text={title} textLength={42} />
                                        </p>
                                    </Link>
                                    <div className={styles.userInfo}>
                                        <SVGIcon style={{ image: styles.icon }} src={IconUser} />
                                        <Link to={`/blog/${user && user.username}/`} className={styles.username}>
                                            {user && displayedName(user)}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default Styled(defaultStyles)(PanelPosts);
